<h1 id="user-info-heading" class="sr-only" tabindex="-1" aria-hidden="false">User Information</h1>

<form [formGroup]="userInfoForm">
  <div class="grid grid-cols-2 gap-4">
    <div class="flex flex-col mb-4">
      <label class="mb-2 font-bold field-required" for="first-name">First Name</label>
      <input
        id="first-name"
        type="text"
        pInputText
        placeholder="Enter First Name"
        formControlName="firstName"
        autocomplete="given-name"
      >
      @if (userInfoForm.controls['firstName'].hasError('required') && (userInfoForm.controls['firstName'].dirty || userInfoForm.controls['firstName'].touched)) {
        <small class="p-error">
          First Name is Required.
        </small>
      }
      @if (userInfoForm.controls['firstName'].hasError('maxlength')) {
        <small class="p-error">
          Must be up to 50 characters long.
        </small>
      }
    </div>
    <div class="flex flex-col mb-4">
      <label class="mb-2 font-bold field-required" for="last-name">Last Name</label>
      <input
        id="last-name"
        type="text"
        pInputText
        formControlName="lastName"
        autocomplete="family-name"
        placeholder="Enter Last Name"
      >
      @if (userInfoForm.controls['lastName'].hasError('required') && (userInfoForm.controls['lastName'].dirty || userInfoForm.controls['lastName'].touched)) {
        <small class="p-error">
          Last Name is Required.
        </small>
      }
      @if (userInfoForm.controls['lastName'].hasError('maxlength')) {
        <small class="p-error">
          Must be up to 50 characters long.
        </small>
      }
    </div>
    <div class="flex flex-col mb-4">
      <label class="mb-2 font-bold field-required" for="fax">Preferred Business Fax (No Dashes)</label>

      <p-inputmask
        inputId="fax"
        styleClass="w-full"
        formControlName="preferredBusinessFax"
        placeholder="9999999999"
        mask="(999) 999 9999"
        [unmask]="true"
        [autoClear]="false"
        autocomplete="tel"
      />
      <small class="p-error text-small">
        *** Please be advised that confidential patient information will be sent to this fax number***
      </small>
      @if (userInfoForm.controls['preferredBusinessFax'].hasError('required') && (userInfoForm.controls['preferredBusinessFax'].dirty || userInfoForm.controls['preferredBusinessFax'].touched)) {
        <small class="p-error text-small">
          Fax is Required.
        </small>
      }
      @if (userInfoForm.controls['preferredBusinessFax'].hasError('maxlength') && (userInfoForm.controls['preferredBusinessFax'].dirty || userInfoForm.controls['preferredBusinessFax'].touched)) {
        <small class="p-error text-small">
          Fax Number has too many numbers. Must be 10 digits and no symbols.
        </small>
      }
      @if (userInfoForm.controls['preferredBusinessFax'].hasError('minlength') && (userInfoForm.controls['preferredBusinessFax'].dirty || userInfoForm.controls['preferredBusinessFax'].touched)) {
        <small class="p-error text-small">
          Fax Number is missing numbers. Must be 10 digits and no symbols.
        </small>
      }
    </div>
    <div class="flex flex-col mb-4">
      <label class="mb-2 font-bold field-required" for="phone">Preferred Business Phone (No Dashes)</label>
      <p-inputmask
        inputId="phone"
        styleClass="w-full"
        formControlName="preferredBusinessPhone"
        placeholder="9999999999"
        mask="(999) 999 9999"
        autocomplete="tel"
        [unmask]="true"
        [autoClear]="false"
      />
      @if (userInfoForm.controls['preferredBusinessPhone'].hasError('required') && (userInfoForm.controls['preferredBusinessPhone'].dirty || userInfoForm.controls['preferredBusinessPhone'].touched)) {
        <small class="p-error">
          Phone is Required.
        </small>
      }
      @if (userInfoForm.controls['preferredBusinessPhone'].hasError('maxlength') && (userInfoForm.controls['preferredBusinessPhone'].dirty || userInfoForm.controls['preferredBusinessPhone'].touched)) {
        <small class="p-error">
          Phone Number has too many numbers. Must be 10 digits and no symbols.
        </small>
      }
      @if (userInfoForm.controls['preferredBusinessPhone'].hasError('minlength') && (userInfoForm.controls['preferredBusinessPhone'].dirty || userInfoForm.controls['preferredBusinessPhone'].touched)) {
        <small class="p-error">
          Phone Number is missing numbers. Must be 10 digits and no symbols.
        </small>
      }
    </div>
    <div class="flex flex-col mb-4">
      <label class="mb-2 font-bold" for="phone-ext">Phone Number Extension</label>
      <input
        id="phone-ext"
        class="inputStyle"
        type="text"
        pInputText
        formControlName="phoneNumberExtension"
        autocomplete="tel-extension"
        placeholder="Enter Phone Extension"
      >
      @if (userInfoForm.controls['phoneNumberExtension'].hasError('maxlength') && (userInfoForm.controls['phoneNumberExtension'].dirty || userInfoForm.controls['phoneNumberExtension'].touched)) {
        <small class="p-error text-small">
          Phone Number Extension has too many characters. Must be maximum of 9.
        </small>
      }
    </div>
  </div>
</form>

<div class="flex justify-end">
  <button
    pButton
    label="Continue"
    type="submit"
    class="p-button-warning"
    [disabled]="!isUserInfoValid"
    (click)="handleNextClick()"
  >
  </button>
</div>
